import { render, staticRenderFns } from "./verificationLogin.vue?vue&type=template&id=9fd4e4e6"
import script from "./verificationLogin.vue?vue&type=script&lang=js"
export * from "./verificationLogin.vue?vue&type=script&lang=js"
import style0 from "./verificationLogin.vue?vue&type=style&index=0&id=9fd4e4e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports